module.exports = __webpack_public_path__ + "img/cnd_Server_cluster.5b0acdbf.svg";